import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CtaBanner() {
  const navigate = useNavigate();
  return (
    <section className="relative bg-[#1e1b4b] text-white overflow-hidden py-16 sm:py-20">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-20%] left-[10%] w-48 h-48 sm:w-72 sm:h-72 lg:w-[400px] lg:h-[400px] bg-violet-600 opacity-20 rounded-full blur-[80px] sm:blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[5%] w-40 h-40 sm:w-64 sm:h-64 lg:w-[350px] lg:h-[350px] bg-amber-500 opacity-15 rounded-full blur-[60px] sm:blur-[100px]" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <span className="inline-block bg-white/5 border border-white/10 text-amber-300 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-5 sm:mb-6">
          Fly Smart. Save Big.
        </span>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-4 sm:mb-6">
          Your Next Trip is
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-violet-400">
            One Click Away
          </span>
        </h2>
        <p className="text-white/60 text-base sm:text-lg max-w-xl mx-auto mb-8 sm:mb-10">
          Join 2 million+ smart travelers who book with FlightBooKaro — India's fastest, cheapest flight booking platform.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-violet-700 to-amber-500 hover:from-violet-600 hover:to-amber-400 text-white font-bold px-8 sm:px-10 py-3.5 sm:py-4 rounded-2xl text-sm sm:text-base transition-all shadow-2xl shadow-violet-700/20 hover:-translate-y-0.5 w-full sm:w-auto"
          >
            Search Flights Now →
          </button>
          <a
            href="tel:+18558958503"
            className="flex items-center justify-center gap-2 border-2 border-white/20 hover:border-white/40 text-white font-semibold px-8 sm:px-10 py-3.5 sm:py-4 rounded-2xl text-sm sm:text-base transition-all hover:bg-white/5 w-full sm:w-auto"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
            </svg>
            Call Our Experts
          </a>
        </div>
      </div>
    </section>
  );
}
